import React from 'react'
import styled from '@emotion/styled'
import Link from 'next/link'
import { Topic } from 'services/ContentfulService/models/topics'
import ContentfulImage from 'experiences/shared/ContentfulImage'

interface Props {
	topic: Topic
}

export const TopicCard = ({ topic }: Props): JSX.Element => (
	<Link href={topic.relativePath} legacyBehavior>
		<TopicCardWrapper>
			<TopicCardTop>
				{topic.graphic && (
					<GraphicWrapper>
						<ContentfulImage
							asset={topic.graphic}
							layout="intrinsic"
							objectFit="contain"
							objectPosition="bottom"
							placeholder={false}
						/>
					</GraphicWrapper>
				)}
			</TopicCardTop>
			<TopicCardBottom>
				<Link href={topic.relativePath} passHref legacyBehavior>
					<Title>{topic.name}</Title>
				</Link>
			</TopicCardBottom>
		</TopicCardWrapper>
	</Link>
)

const Title = styled.a`
	color: rgb(13, 8, 8);
	text-decoration: none;
	font-size: 18px;
	font-weight: bold;
`

const GraphicWrapper = styled.div`
	max-width: 65%;
	height: 79%;
	width: 60%;
	display: flex;
`

const TopicCardWrapper = styled.div`
	cursor: pointer;
	border-radius: 8px;
	box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.08);
	background-color: #ffffff;
	transition: 0.3s;
	height: 100%;

	&:hover {
		transform: translateY(-5px);
	}
`

const TopicCardTop = styled.div`
	height: 111px;
	background-color: #f9f2ff;
	position: relative;
	display: flex;
	align-items: flex-end;
	justify-content: center;
`

const TopicCardBottom = styled.div`
	padding: 24px;
	font-size: 18px;
	font-weight: bold;
	color: #0d0808;
	text-align: left;

	a,
	h3 {
		color: #0d0808;
		text-decoration: none;
		font-size: 18px;
		font-weight: bold;
		:hover {
			color: initial;
		}
	}
`
